
$(document).ready(function($) {

  $(".toggle-footer-icon").click(function(){
    $(this).toggleClass("active");
    $(".toggle-footer-div").slideToggle();
  });

  $(".mobile-toggle-icon").click(function(){
    $('.mobile-menu').html($('.menu').html());
    toggelName();
  });

  $(".collection-mobile-toggle").click(function(){
    $('.mobile-menu').html($('.collection-col-one').html());
    $(".mobile-toggle-menu, .overlay").addClass("active");
    toggelName();
  });

  $(".mobile-toggle-min-menu").click(function(){
    $(this).parent().find(".min-submenu").slideToggle("active");
  });

  $(".accordion").click(function(){
    $(this).parent().find(".panel").slideToggle("active");
  });

  $(".discount-code").click(function(){
    $(".dis-code-input").slideToggle("");
  });

  $(".mobile-toggle-icon").click(function(){
    $(".mobile-toggle-menu, .overlay").addClass("active");
  });

  $(".overlay, .mobile-toggle-close").click(function(){
    $(".mobile-toggle-menu, .overlay").removeClass("active");
  });
  toggelName();
  $(".submenu-heading").click(function(){
    $(this).parent().find(".submenu-list-items").slideToggle("");
  });

  $(".submenu-list a, .mobile-toggle-min-menu").click(function(e){
    e.preventDefault();
    $(this).toggleClass("active");
  });


 
    $('ul.accordion li').click(function(){
      var tab_id = $(this).attr('data-tab');

      $('ul.accordion li').removeClass('current');
      $('.tab-content').removeClass('current');

      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
    });

  



  $('body').on('click', '.adjust', function(){
    var ip = parseInt($(this).parent().find('input').val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      ip = 1;
    }
    $(this).parent().find('input').val(ip);
  });


// //   	$('.home-slider').slick({
// //   		dots:false,
// //   		arrows: false,
// //   		infinite:true,
// //   		slidesToShow:1,
// //   		slidesToScroll:1,
// //   		autoplay:true,
// //   		autoplaySpeed:3000,
// //   	});

// //   	$('.product-img-list-slider').slick({
// //   		dots:false,
// //   		arrows: true,
// //   		infinite:true,
// //   		slidesToShow:4,
// //   		prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><img src="file:///E:/Projects/houseofisabella/images/slider-right-icon.png" alt=""/></button>',
// //           nextArrow: '<button class="slick-next" aria-label="Next" type="button"><img src="file:///E:/Projects/houseofisabella/images/slider-left-icon.png" alt=""/></button>',
// //   		slidesToScroll:1,
// //   		autoplay:false,
// //   		autoplaySpeed:3000,
// //   	});

// //   	$('.rel-pro-slider').slick({
// //   		dots:false,
// //   		arrows: true,
// //   		infinite:true,
// //   		slidesToShow:3,
// //   		prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><img src="file:///E:/Projects/houseofisabella/images/slider-right-icon.png" alt=""/></button>',
// //           nextArrow: '<button class="slick-next" aria-label="Next" type="button"><img src="file:///E:/Projects/houseofisabella/images/slider-left-icon.png" alt=""/></button>',
// //   		slidesToScroll:1,
// //   		autoplay:false,
// //   		autoplaySpeed:3000,
// //   		responsive: [
// //         {
// //           breakpoint: 767,
// //           settings: {
// //             slidesToShow: 2,
// //             arrows: true
// //           }
// //         },
// //         {
// //           breakpoint: 400,
// //           settings: {
// //             slidesToShow: 1,
// //             arrows: true
// //           }
// //         }
// //       ]
// //   	});




  //quick-view
  function closePopup() {
    $('.popupBox').removeClass('slideInDown');
    $('.popupBox').addClass('slideOutUp');
    $('.popupOverlay').fadeOut('slow');
  }

  function openPopup(a) {
    $('.popupBox').addClass('slideInDown');
    $('.popupBox').removeClass('slideOutUp');
    $('.popupOverlay.'+a).fadeIn('slow');
  }
//   $('.openQv').on('click','.popupinfo',function(e){
//     e.preventDefault();
//     var id = $(this).data('href');
//     openPopup(id);
//   });
  $('.openQv').on('click','.cls_popup',function(e){
    e.preventDefault();
    closePopup();
  });
//   $(document).keyup(function(e) {
//     if (e.keyCode == 27) { 
//       closePopup();
//     }
//   });
  window.onclick = function(e) {
    if ($(e.target).hasClass('popupOverlay')) {
      closePopup();
    }
  }
  $('.openQv').on('click', function(e){
    $(this).attr('disabled','disabled');
    $('.qvProduct').removeAttr('style');
    var url = $(this).attr("href");
    e.preventDefault();
    $.get( url, function( data ) {
      $('#qvProductContent').html(data);
      openPopup('qvPopup');
//       $('.puList').slick({
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         infinite: false
//       });

//       $('.qv_main').slick({
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: false,
//         fade: true,
//         asNavFor: '.qv_thumb'
//       });
//       $('.qv_thumb').slick({
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         asNavFor: '.qv_main',
//         dots: false,
//         focusOnSelect: true,
//         arrows: true,
//       });

      $('.addtocartForm').on('submit', function(e){
        e.preventDefault();
        $('#AddToCart').attr('disabled');
        $('#AddToCart span').text('Adding..');
        var form = $(this);
        $('.puadd:checked').each(function(){
          var id = $(this).attr('data-id');
          $.ajax({
            url: '/cart/add.js',
            data: { id: id },
            type: 'POST',
            dataType: 'json',
            async:false
          });
        });
        $.ajax({
          url: '/cart/add.js',
          data: form.serialize(),
          type: 'POST',
          dataType: 'json',
          async:false,
          success: function(){
            $('#AddToCart').removeAttr('disabled');
            $('#AddToCart span').text('Added.');
            closePopup();
            addToCartSuccess();
            $.getJSON('/cart.js', function(cart){
              refreshCart(cart);
            });
            $('.productGrid .productItem').removeClass('qvopen');
            $('body').addClass('cartOpen');
            $('.fullPage').addClass('witmenu');
          }
        });
      });

    });
    $('.openQv').removeAttr('disabled');
  });


});


function toggelName(){
  $(".filter-head").click(function(){	
    $(this).parent().find(".filter-toggle").slideToggle();  
    $(this).slideToggle("display","block"); 
  });	
  $(".mobile-toggle-min-menu").click(function(){
    $(this).parent().find(".min-submenu").slideToggle("active");
  });
  $(".submenu-heading").click(function(){
    $(this).parent().find(".submenu-list-items").slideToggle("");
  });
  $(".submenu-list a, .mobile-toggle-min-menu").click(function(e){

    $(this).toggleClass("active");
  });
}

//  $('.slider-for').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   fade: true,
//   asNavFor: '.slider-nav'
// });
// $('.slider-nav').slick({
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   asNavFor: '.slider-for',
//   dots: true,
//   centerMode: true,
//   focusOnSelect: true
// });




$(document).ready(function(){
$(function() {
  // Current Ajax request.
  var currentAjaxRequest = null;
  // Grabbing all search forms on the page, and adding a .search-results list to each.
  var searchForms = $('form[action="/search"]').css('position','relative').each(function() {
    // Grabbing text input.
    var input = $(this).find('input[name="q"]');
    // Adding a list for showing search results.
    var offSet = input.height();
    $('<ul class="search-results"></ul>').appendTo($(this)).hide();    
    // Listening to keyup and change on the text field within these search forms.
    input.attr('autocomplete', 'off').bind('keyup change', function() {
      // What's the search term?
      var term = $(this).val();
      // What's the search form?
      var form = $(this).closest('form');
      // What's the search URL?
      var searchURL = '/search?type=product&q=' + term;
      // What's the search results list?
      var resultsList = form.find('.search-results');
      // If that's a new term and it contains at least 3 characters.
      if (term.length > 1 && term != $(this).attr('data-old-term')) {
        // Saving old query.
        $(this).attr('data-old-term', term);
        // Killing any Ajax request that's currently being processed.
        if (currentAjaxRequest != null) currentAjaxRequest.abort();
        // Pulling results.
        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
          // Reset results.
          resultsList.empty();
          // If we have no results.
          if(data.results_count == 0) {
            // resultsList.html('<li><span class="title">No results.</span></li>');
            // resultsList.fadeIn(200);
            resultsList.hide();
          } else {
            // If we have results.
            $.each(data.results, function(index, item) {
              var link = $('<a></a>').attr('href', item.url);
              link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
              link.append('<span class="title">' + item.title + '</span>');
              link.wrap('<li></li>');
              resultsList.append(link.parent());
            });
            // The Ajax request will return at the most 10 results.
            // If there are more than 10, let's link to the search results page.
            if(data.results_count > 10) {
              resultsList.append('<li><span class="title"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></span></li>');
            }
            resultsList.fadeIn(200);
          }        
        });
      }
    });
  });
  // Clicking outside makes the results disappear.
  $('body').bind('click', function(){
    $('.search-results').hide();
  });
}); 
  });

  //minicart


$(document).ready(function(){
  function addToCartSuccess() {
    $.get( "/cart?view=mini", function( data ) {
      $('#crt').html(data);
      $('#crt').removeClass('loading');
    });
  }
  function refreshCart(cart) {
    $('.cart-count').text(cart.item_count);
  }

  $('#AddToCart').on('click','product-form__cart-submit',function(e){

    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    btn.attr('disabled', 'disabled');
    btn.text('adding...');
    form.find('.error').remove();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        btn.text('AddToCart');
        btn.removeAttr('disabled');
      }
    }).done(function( data ) {
      addToCartSuccess();
      btn.text('AddToCart');
      btn.removeAttr('disabled');
      $.getJSON('/cart.js', function(cart){
        refreshCart(cart);
      });
      $('.productGrid .productItem').removeClass('qvopen');
      $('#AddToCart').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');
    });

  });

  $('#AddToCart').on('click','.fullPage.witmenu, .closemenu, .closecart', function(e){
    e.preventDefault();
    $('#AddToCart').removeClass('menuOpen');
    $('.fullPage').removeClass('witmenu');
    $('#AddToCart').removeClass('cartOpen');
  });
  $('.site-header__cart').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('v').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');
    }, 50);
  });
  $('#AddToCart').on('click', '.adjust',function(){
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);

    $('#crt').addClass('loading');
    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        //alert(response.description);
        $('#crt').removeClass('loading');
      }
    }).done(function( data ) {
      addToCartSuccess();
      $.getJSON("/cart.js", function(cart) {
        refreshCart(cart);
      });
      $('#crt').removeClass('loading');
    });

  });
  $("#crt").on('click', "a.remove_item", function(r){
    $('#crt').addClass('loading');
    r.preventDefault();
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      $('.itemCount').text(c.item_count);
      if(!c.item_count) {
        $('#crt').empty();
        $('#crt').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
        $('#crt').removeClass('has-item');
        $('#crt').removeClass('loading');
        $.getJSON("/cart.js", function(cart) {
          refreshCart(cart);
        });
      } else {
        addToCartSuccess();
      }
    });
    $.getJSON("/cart.js", function(cart) {
      refreshCart(cart);
    });
  });
});

$(document).ready(function(){
  $("#AddToCart").mouseenter(function(){
    $(".miniCart").css("display", "block");
  });
  $("#AddToCart").mouseleave(function(){
    $(".miniCart").css("display", "none");
  });
});
//newsletter
$(document).ready(function(){
  $("#AddToCart").click(function () {
        $(".miniCart").css("display","none")
        $(".miniCart").css("display","block")
        // $("#").show();   
    });
  $(".fa-chevron-left").click(function(){
    $(".miniCart").hide(400);
  
  });

});

function addToCartSuccess() {
  $.get( "/cart?view=mini", function( data ) {
    $('#crt').html(data);
    $('#crt').removeClass('loading');
  });
}
function refreshCart(cart) {
  $('.cart-count').text(cart.item_count);
}

$(document).ready(function(){
  $(".openQv").click(function () {
        $(".quickView").css("display","none")
        $(".quickView").css("display","block")
        // $("#").show();   
    });
  $(".fa-chevron-left").click(function(){
    $(".miniCart").hide(400);
  
  });

});

function addToCartSuccess() {
  $.get( "/cart??view=quick_view", function( data ) {
    $('#crt').html(data);
    $('#crt').removeClass('loading');
  });
}
function refreshCart(cart) {
  $('.cart-count').text(cart.item_count);
}

//quick view related product
// function closePopup() {
//   $('.popupBox').removeClass('slideInDown');
//   $('.popupBox').addClass('slideOutUp');
//   $('.popupOverlay').fadeOut('slow');
// }

// function openPopup(a) {
//   $('.popupBox').addClass('slideInDown');
//   $('.popupBox').removeClass('slideOutUp');
//   $('.popupOverlay.'+a).fadeIn('slow');
// }
// $('body').on('click','.popupinfo',function(e){
//   e.preventDefault();
//   var id = $(this).data('href');
//   openPopup(id);
// });
// $('body').on('click','.cls_popup',function(e){
//   e.preventDefault();
//   closePopup();
// });
// $(document).keyup(function(e) {
//   if (e.keyCode == 27) { 
//     closePopup();
//   }
// });
// window.onclick = function(e) {
//   if ($(e.target).hasClass('popupOverlay')) {
//     closePopup();
//   }
// }
// $('.openQv').on('click', function(e){
//   $(this).attr('disabled','disabled');
//   $('.qvProduct').removeAttr('style');
//   var url = $(this).attr("href");
//   e.preventDefault();
//   $.get( url, function( data ) {
//     $('#qvProductContent').html(data);
//     openPopup('qvPopup');
//     $('.puList').slick({
//       slidesToShow: 2,
//       slidesToScroll: 1,
//       infinite: false
//     });

//     $('.qv_main').slick({
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows: false,
//       fade: true,
//       asNavFor: '.qv_thumb'
//     });
//     $('.qv_thumb').slick({
//       slidesToShow: 2,
//       slidesToScroll: 1,
//       asNavFor: '.qv_main',
//       dots: false,
//       focusOnSelect: true,
//       arrows: true,
//     });

//     $('.addtocartForm').on('submit', function(e){
//       e.preventDefault();
//       $('#AddToCart').attr('disabled');
//       $('#AddToCart span').text('Adding..');
//       var form = $(this);
//       $('.puadd:checked').each(function(){
//         var id = $(this).attr('data-id');
//         $.ajax({
//           url: '/cart/add.js',
//           data: { id: id },
//           type: 'POST',
//           dataType: 'json',
//           async:false
//         });
//       });
//       $.ajax({
//         url: '/cart/add.js',
//         data: form.serialize(),
//         type: 'POST',
//         dataType: 'json',
//         async:false,
//         success: function(){
//           $('#AddToCart').removeAttr('disabled');
//           $('#AddToCart span').text('Added');
//           closePopup();
//           addToCartSuccess();
//           $.getJSON('/cart.js', function(cart){
//             refreshCart(cart);
//           });
//           $('.productGrid .productItem').removeClass('qvopen');
//           $('body').addClass('cartOpen');
//           $('.fullPage').addClass('witmenu');
//         }
//       });
//     });

//   });
//   $('.openQv').removeAttr('disabled');
// });


//   jQuery(document).ready(function(){	
// 	jQuery('.closeNew').click(function(){
// 			jQuery('#popup-container').fadeOut();
// 			jQuery('#active-popup').fadeOut();
// 	});
	
// 	var visits = jQuery.cookie('visits') || 0;
// 	visits++;
	
// 	jQuery.cookie('visits', visits, { expires: 1, path: '/' });
		
// 	console.debug(jQuery.cookie('visits'));
		
// 	if ( jQuery.cookie('visits') > 1 ) {
// 		jQuery('#active-popup').hide();
// 		jQuery('#popup-container').hide();
// 	} else {
// 			var pageHeight = jQuery(document).height();
// 			jQuery('<div id="active-popup"></div>').insertBefore('body');
// 			jQuery('#active-popup').css("height", pageHeight);
// 			jQuery('#popup-container').show();
// 	}

// 	if (jQuery.cookie('noShowWelcome')) { jQuery('#popup-container').hide(); jQuery('#active-popup').hide(); }
// });	

// jQuery(document).mouseup(function(e){
// 	var container = jQuery('#popup-container');
	
// 	if( !container.is(e.target)&& container.has(e.target).length === 0)
// 	{ 
// 		container.fadeOut();
// 		jQuery('#active-popup').fadeOut();
// 	}

// });




// -------------------------- mini cart ---------------------------
  
  
   // Add Cart

  $(document).ready( function(){
    function addcart(){
      $.get('/cart/?view=mini-cart',function(data){
        $('.minicartNew').html(data);
        $('.minicartNew').removeClass('loading');
      });
    }
    function refreshcart(cart){
      $('.cart-countNew').text(cart.item_count);
    }
    $('.justselect1').change('input', function() {
      $( ".btnupdate" ).trigger( "click" );
    });
    $('#add-to-cart').click(function(e){
      var form=$(this).closest("form");
      $('.justselect1').removeAttr("disabled");
      e.preventDefault();
      $.ajax({
        type:"GET",
        url:"/cart/add.js",
        data:form.serialize(),
        dataType:"JSON"
      }).done(function(data){
        addcart();
        $.getJSON('/cart.js',function(cart){
          refreshcart(cart);
        });
        console.log(data);
        $('.justselect1').attr("disabled",true);
      });
    });

    // Update Cart

    $('body').on('click', '.adjust',function(){
      var input = $(this).parent().find('input');
      var ip = parseInt(input.val());
      console.log(ip);
      if($(this).hasClass('plus')){
        ip=ip+1;
      }else{
        ip=ip-1;
      }
      if(ip==0){
        return false;
      }
      input.val(ip);
      $('.cart-listNew').addClass('loading');
      var id = parseInt(input.attr('data-id'));
      $.ajax({
        type: 'GET',
        url: '/cart/update.js',
        data: 'updates['+id+']='+ip,
        dataType: 'json'
      }).done(function(data){
        addcart()
        $.getJSON("/cart.js", function(cart){
          refreshcart(cart);
        });
        $('.cart-listNew').removeClass('loading');
        console.log(data);
      });
    });
    // Remove Cart
    $(".cart-listNew").on('click', "a.btn-effectNew", function(e){
      alert("hii0");
      $('.cart-listNew').addClass('loading');
      e.preventDefault();
      var id = $(this).data("id");
      alert(id);
      Shopify.changeItem(id,0, function(c){
        $('.cart-countNew').text(c.item_count);
        if(!c.item_count) {
          $('.minicartNew').empty();
          $('.minicartNew').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
          $('.minicartNew').removeClass('has-item');
          $('.minicartNew').removeClass('loading');
          $.getJSON("/cart.js", function(cart){
            refreshcart(cart);
          });
        } else {
          addcart();
        }
      });
      $.getJSON("/cart.js", function(cart) {
        refreshcart(cart);
      });
    });
  });
